const OverviewSVG = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="1"
      width="7"
      height="4"
      rx="2"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <rect
      x="1.5"
      y="8"
      width="7"
      height="10"
      rx="2.5"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <rect
      x="11.5"
      y="1"
      width="7"
      height="10"
      rx="2.5"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <rect
      x="11.5"
      y="14"
      width="7"
      height="4"
      rx="2"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
  </svg>
);

const OverviewSVGSelected = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="7"
      height="4"
      rx="2"
      fill="#C44A25"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
    <rect
      x="1"
      y="8"
      width="7"
      height="10"
      rx="2.5"
      fill="#C44A25"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
    <rect
      x="11"
      y="1"
      width="7"
      height="10"
      rx="2.5"
      fill="#C44A25"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
    <rect
      x="11"
      y="14"
      width="7"
      height="4"
      rx="2"
      fill="#C44A25"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
  </svg>
);

export { OverviewSVG, OverviewSVGSelected };
